import { render, staticRenderFns } from "./vip-button-trial.vue?vue&type=template&id=c629e9cc&scoped=true&lang=pug&"
import script from "./vip-button-trial.vue?vue&type=script&lang=js&"
export * from "./vip-button-trial.vue?vue&type=script&lang=js&"
import style0 from "./vip-button-trial.vue?vue&type=style&index=0&id=c629e9cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c629e9cc",
  null
  
)

export default component.exports